import { MenuItem } from '@src/common/components/Menu';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useCurrentOrderMode } from '@src/orders/hooks/useCurrentOrderMode';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
};
export const ReviewAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const { setCurrentMode } = useCurrentOrderMode();

  const reviewOrder = () => setCurrentMode({ mode: 'review' });

  return (
    order.canDo(OrderActions.REVIEW) && (
      <MenuItem key={`${order.id}-review`} onClick={reviewOrder}>
        {t('review')}
      </MenuItem>
    )
  );
};
